import { Factory } from '../../services/Factory';

export interface IRoleEditorScope extends ng.IScope {
    availablePermissions: Array<any>,
    permissions: Array<any>;
    role: any,
    project: any;
    save: Function,
    remove: Function
}

export interface IRoleEditorAttributes extends ng.IAttributes {
}

export class RoleEditor implements ng.IDirective {
    public restrict:string = 'E';
    public link:(scope: IRoleEditorScope, element:ng.IAugmentedJQuery, attrs: IRoleEditorAttributes) => void;
    public templateUrl:string;
    public scope = {
        availablePermissions :'=',
        role :'=',
        project :'='
    };

    constructor() {
        this.templateUrl = `partials/role_editor.html`;
        this.link = (scope: IRoleEditorScope, element:ng.IAugmentedJQuery, attrs: IRoleEditorAttributes) => {
            scope.permissions = _.map(scope.availablePermissions, _.clone);
            scope.permissionCategories = _.map(_.unique(scope.permissions, p => p.category), p => p.category);

            scope.permissions.forEach(p => p.checked = !!_.find(scope.role.permissions, ap => ap.name === p.name));

            scope.tagFilter = {...scope.role.tagRestriction};

            scope.save = role => {
                scope.role.permissions = [];

                scope.permissions.forEach(permission => {
                    if (permission.checked) {
                        scope.role.permissions.push(permission);
                    }
                });

                const tagRestriction = {
                    'and': [],
                    'or': [],
                    'not': []
                };

                scope.tagFilter.and.forEach(tag => tagRestriction.and.push(tag.id));
                scope.tagFilter.or.forEach(tag => tagRestriction.or.push(tag.id));
                scope.tagFilter.not.forEach(tag => tagRestriction.not.push(tag.id));

                role.tagRestriction = tagRestriction;

                scope.$emit('SaveRole', role);
            };

            scope.remove = role => {
                scope.$emit('RemoveRole', role);
            };
        }
    }
}

frontendApp.directive("iioRoleEditor", [Factory.Create(RoleEditor)]);
